// Basic
import PropTypes from 'prop-types';
// Components
import Dropdown from '../../dropdown/Dropdown';
import Entity from '../../entity/Entity';
import { Button } from '@/common-utils/components/ui/button';
import TooltipAndDropdownHelper from '../../tooltipAndDropdown/TooltipAndDropdownHelper';

/**
 * @param root0
 * @param root0.action
 * @param root0.isMediumDevice
 * @param root0.retractable
 * @param root0.translate
 * @param root0.variant
 * @returns {JSX} RenderDropdownAction
 */
function RenderDropdownAction({ action, isMediumDevice, retractable, translate, variant }) {
    const { subActions, trigger } = action;
    if (isMediumDevice && retractable) {
        return (
            <TooltipAndDropdownHelper
                trigger={
                    <Button
                        disabled={trigger.disabled}
                        title={trigger.disabled ? translate(trigger.tooltipForbidden) : undefined}
                        icon={trigger.icon}
                        variant={variant}
                        className='h-8 rounded-lg px-2'
                    />
                }
                tooltipContent={
                    <Entity
                        entity={trigger.entity}
                        namespace={trigger.namespace}
                        nowrap
                    />
                }
                actions={subActions}
            />
        );
    }

    return (
        <Dropdown
            actions={subActions}
            trigger={
                <Button
                    disabled={trigger.disabled}
                    title={trigger.disabled ? translate(trigger.tooltipForbidden) : undefined}
                    icon={trigger.icon}
                    entity={trigger.entity}
                    namespace={trigger.namespace}
                    variant={variant}
                    className='h-8 rounded-lg pl-1 pr-2'
                />
            }
        />
    );
}

RenderDropdownAction.propTypes = {
    action: PropTypes.object,
    isMediumDevice: PropTypes.bool,
    retractable: PropTypes.bool,
    translate: PropTypes.func,
    variant: PropTypes.string
};
export default RenderDropdownAction;